export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/03827f5dae6760b4d294d66a307d6411.png";